import dayjs from "dayjs";
import styled from "styled-components";
import { InputStyled } from "./form-item-string";
import { useAdvancedFormContext } from "../advanced-form";
import LocalizedDatePicker from "../../util/localized-date-picker";
import { useCallback } from "react";

const DatePickerStyled = styled(LocalizedDatePicker)`
  width: 100%;
`

function DatePickerWrapper({ placeholder, value, onChange, readOnly }: any) {
  if(typeof value === "string") {
    value = dayjs(value);
  } 

  const onChangeInternal = useCallback((date) => {
    console.log("Date changed", date);
    onChange(date ? date.second(0).millisecond(0) : null);
  }, [onChange]);

  return (
    <DatePickerStyled disabled={readOnly} placeholder={placeholder} format={'DD.MM.YYYY HH:mm'} value={value} onChange={onChangeInternal} showTime={{ format: 'HH:mm' }} />
  )
}

function FormItemDatetime({ readOnly, disabled, label, value, onChange, typeData }: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  return (
    <>
      { effectiveReadOnly &&  <InputStyled value={value ? dayjs(value).format('DD.MM.YYYY HH:mm') : undefined} readOnly />}
      { !effectiveReadOnly && <DatePickerWrapper value={value} onChange={onChange} readOnly={readOnly} disabled={disabled} placeholder={label} picker={typeData?.picker} /> }
    </>
  )
}

export default FormItemDatetime;